/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiRequiredFieldOutboundTender.ts  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-required-field-outbound-tender";

export class AutogenModelEdiRequiredFieldOutboundTender<RowType extends ModelRow> extends Endpoint<RowType, RowEdiRequiredFieldOutboundTenderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiRequiredFieldOutboundTender extends ModelRow<RowEdiRequiredFieldOutboundTenderFields> {
	constructor(values?: Partial<RowEdiRequiredFieldOutboundTenderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiRequiredFieldOutboundTenderFields {
	alt_partner_id: string;
	company_id: string;
	direction: string;
	error_code: number;
	error_descr: string;
	event_id: string;
	field_name: string;
	group_id: string;
	id: string;
	is_active: string;
	location_id: string;
	parent_row_id: string;
	parent_row_type: string;
	partner_id: string;
	pass_when_type: string;
	rule_type: string;
	sequence: number;
	table_name: string;
	transaction_set: string;
	version: string;
	which_stop: string;
}

